@let user = user$ | async;
@let submenuOpened = submenuOpened$ | async;
@let selectedMenuItem = selectedMenuItem$ | async;
@let isOpenSidebarMenu = isOpenSidebarMenu$ | async;
@let isOpenMobileMenu = isOpenMobileMenu$ | async;

<app-header></app-header>

<mat-drawer-container [hasBackdrop]="false">
  <mat-drawer-content class="layout-container" [ngClass]="{ white: isWhiteBg }">
    <div
      class="wrapper"
      [ngClass]="{
        active: submenuOpened,
        open: isOpenMobileMenu,
        close:
          (!isOpenMobileMenu && isMobile) || (!isOpenSidebarMenu && !isMobile)
      }">
      <button
        [ngClass]="{ active: !submenuOpened }"
        mat-button
        (click)="toggleSubMenu(true)">
        <img src="assets/svg/circle-chevron-left.svg" alt="Arrow" />
      </button>

      <div
        class="wrapper_content"
        [ngClass]="{ submenuOpened: !submenuOpened }">
        <div class="btnsContainer">
          @for (menuItem of menuItems; track menuItem.routerLink) {
            @if (
              hasRequiredRole(menuItem.requiredRoles) &&
              hasFunctionAccess(menuItem.requiredFunctions)
            ) {
              <a
                (click)="selectMenuItem(menuItem, submenuOpened)"
                [routerLink]="menuItem.routerLink"
                routerLinkActive="activeBtn"
                [matTooltip]="menuItem.title | translate"
                matTooltipShowDelay="300"
                matTooltipPosition="right"
                class="sideBarBtn">
                <img [src]="menuItem.iconSrc" width="32" height="32" alt="" />
                <p>
                  {{ menuItem.title | translate }}
                </p>
              </a>
            }
          }
        </div>

        <div class="helpContainer">
          <a class="sideBarBtnDown" (click)="openInstructionForSupplierModal()">
            <img src="assets/svg/help.svg" alt="Help" />
            <p>{{ 'HELP_CENTER' | translate }}</p>
          </a>
          <a class="sideBarBtnDown">
            <img src="assets/svg/new.svg" alt="New" width="32" height="32" />
            <p>{{ 'WHATS_NEW' | translate }}</p>
          </a>
        </div>
      </div>
    </div>

    @if (
      selectedMenuItem?.subMenu?.length && selectedMenuItem;
      as selectedMenuItem
    ) {
      <div
        class="wrapperSecond"
        [ngClass]="{
          collapsed: submenuOpened === false,
          open: isOpenMobileMenu,
          close:
            (!isOpenMobileMenu && isMobile) || (!isOpenSidebarMenu && !isMobile)
        }">
        <div class="titleContainer">
          <h3 [hidden]="submenuOpened === false">
            {{ selectedMenuItem.title | translate }}
          </h3>
          @if (submenuOpened) {
            <button
              mat-icon-button
              (click)="toggleSubMenu(true)"
              class="toggle-sidebar-button">
              <img
                [src]="
                  submenuOpened
                    ? 'assets/svg/circle-chevron-left.svg'
                    : 'assets/svg/circle-chevron-right.svg'
                "
                alt="hide" />
            </button>
          }
        </div>
        <div class="subNav" [ngClass]="{ hidden: submenuOpened === false }">
          <div class="sub-item">
            @for (
              subItem of selectedMenuItem.subMenu;
              let index = $index;
              track subItem.title + index
            ) {
              @if (
                hasRequiredRole(subItem.requiredRoles) &&
                hasFunctionAccess(subItem.requiredFunctions)
              ) {
                <div class="subGroup">
                  <a
                    (click)="
                      subItem.isRouting
                        ? toggleSubMenu()
                        : toggleSubGroup(index)
                    "
                    class="subGroupTitle"
                    [ngClass]="{ 'base-link': subItem.isRouting }"
                    [routerLink]="subItem.isRouting ? subItem.routerLink : null"
                    routerLinkActive="activeBtnSubmenu">
                    <img
                      class="subGroupImg"
                      [src]="subItem.iconSrc"
                      width="20"
                      height="20"
                      alt="icon" />
                    <h6>{{ subItem.title | translate }}</h6>
                    @if (!subItem.isRouting) {
                      <img
                        class="arrow"
                        [src]="
                          openedSubGroups[index]
                            ? 'assets/svg/arrow-up-small.svg'
                            : 'assets/svg/arrow-down-small.svg'
                        "
                        alt="arrow" />
                    }
                  </a>
                  @if (openedSubGroups[index]) {
                    <div class="subNavGroupItems">
                      @for (item of subItem.subGroup; track item.routerLink) {
                        @if (
                          hasRequiredRole(item.requiredRoles) &&
                          hasFunctionAccess(item.requiredFunctions) &&
                          item.isExternalLink
                        ) {
                          <a
                            routerLinkActive="activeBtnSubmenu"
                            class="subNavGroupItem"
                            (click)="goToLink(item.routerLink)">
                            <h6>{{ item.title | translate }}</h6>
                          </a>
                        } @else if (
                          hasRequiredRole(item.requiredRoles) &&
                          hasFunctionAccess(item.requiredFunctions)
                        ) {
                          <a
                            [routerLink]="item.routerLink"
                            routerLinkActive="activeBtnSubmenu"
                            class="subNavGroupItem subNavSubGroup"
                            (click)="toggleSubMenu()">
                            <h6>{{ item.title | translate }}</h6>
                          </a>
                        }
                      }
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
      </div>
    }

    @if (isOpenMobileMenu) {
      <div class="overlay" (click)="closeMobileMenu(false)"></div>
    }
    <div class="layout-pageContent">
      <app-breadcrumbs />
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>

<app-notification-alert></app-notification-alert>
<app-communication-chart-alert></app-communication-chart-alert>
